import BaseService from '@/ecm/common/BaseService.js';

class CloudDriveService {
    baseUrl = 'cloud-drive';
    getFolderName = (request) => BaseService.post({ url: `${this.baseUrl}/folder-name`, data: request });
    getFolders = (request) => BaseService.post({ url: `${this.baseUrl}/drive-folders`, data: request });
    getUserEmail = (request) => BaseService.post({ url: `${this.baseUrl}/user-email`, data: request });
    createFolder = (request) => BaseService.post({ url: `${this.baseUrl}/create-folder`, data: request });
}

export default new CloudDriveService();